import { Field } from 'redux-form';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReduxField = ({
  component: Component,
  format,
  name,
  normalize,
  onBlur,
  onChange,
  onFocus,
  props,
  validate,
  warn
}) => {
  return /*#__PURE__*/_jsx(Field, {
    component: Component,
    format: format,
    name: name,
    normalize: normalize,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    props: props,
    validate: validate,
    warn: warn
  });
};
//# sourceMappingURL=ReduxAdaptedField.js.map